import React, {useEffect} from "react";
import {makeStyles} from '@mui/styles';
import {ItemInMenuDto, ItemsListMenuDto} from "../../dtos";
import {ItemInMenu} from "./itemInMenu/itemInMenu";
import {ClickAwayListener, Grow, MenuList, Paper, Popper} from "@mui/material";


const useStyles = makeStyles(() => ({
    popper: {
        zIndex: 3
    },
    paper: {
        borderRadius: '5px',
    },
}));

interface Props {
    list: ItemsListMenuDto,
}


export const ClickMenu = (props: Props) => {
    const classes = useStyles();

    const handleClose = (event: any) => {
        // @ts-ignore
        if (props.list.anchorRef.current && props.list.anchorRef.current.contains(event.target)) {
            return;
        }

        props.list.setOpen(false);
    };

    function handleListKeyDown(event: any) {
        if (event.key === 'Tab') {
            event.preventDefault();
            props.list.setOpen(false);
        }
    }

    useEffect(() => {
        if (props.list.prevOpen.current && !props.list.open) {
            // @ts-ignore
            props.list.anchorRef.current!.focus();
        }

        props.list.prevOpen.current = props.list.open;
    }, [props.list.open]);


    const menuList = props.list.menuList?.map((key: ItemInMenuDto, index: number) =>
        <ItemInMenu key={index} item={key} onClick={handleClose}
                    setOpen={props.list.setOpen}/>
    );

    return (
        <>
            <Popper open={props.list.open} anchorEl={props.list.anchorRef.current} role={undefined} transition
                    disablePortal placement={'bottom-start'} className={classes.popper}
            >
                {({TransitionProps, placement}) => (
                    <Grow
                        {...TransitionProps}
                        style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}
                    >
                        <Paper className={classes.paper}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    sx={{
                                        padding: 0,
                                        marginTop: '5px',
                                        borderRadius: '5px',
                                        border: '1px solid #E4810D'
                                    }}
                                    autoFocusItem={props.list.open} id="menu-list-grow"
                                    disablePadding
                                    onKeyDown={handleListKeyDown}>
                                    {menuList}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}